import { render, staticRenderFns } from "./m-auto-assinar.vue?vue&type=template&id=485b1f22&"
import script from "./m-auto-assinar.vue?vue&type=script&lang=js&"
export * from "./m-auto-assinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports